import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ImportCloudProjectsOdxTableComponent } from "@components/cloud-project-odx-tables/import-cloud-projects-odx-table/import-cloud-projects-odx-table.component";
import { CloudProjectMetadata } from "@domain/project/cloud-project-metadata";
import { ProjectService } from "@domain/project/project.service";
import { User } from "@domain/user/user";
import { UserService } from "@domain/user/user.service";
import { AreaHeaderComponent } from "@odx/angular/components/area-header";
import { ButtonComponent } from "@odx/angular/components/button";
import { ModalContentDirective, ModalRef } from "@odx/angular/components/modal";
import { Observable, map, switchMap } from "rxjs";

@Component({
  selector: "app-crm-project-update-modal",
  imports: [
    AreaHeaderComponent,
    AsyncPipe,
    ButtonComponent,
    ImportCloudProjectsOdxTableComponent,
    ModalContentDirective,
    UiKitModule,
  ],
  templateUrl: "./crm-project-update-modal.component.html",
  styleUrl: "./crm-project-update-modal.component.scss",
})
export class CrmProjectUpdateModalComponent {
  private projectService = inject(ProjectService);
  private userService = inject(UserService);

  cloudProjects$: Observable<CloudProjectMetadata[]>;
  selectedProject?: CloudProjectMetadata;
  public readonly modalRef = inject(ModalRef<any, string>);

  constructor() {
    const projectService = this.projectService;

    this.cloudProjects$ = this.userService.user$.pipe(
      switchMap((user: User) => {
        return projectService.loadCloudProjectsMetadata().pipe(
          map((metadata) => {
            return metadata.filter((data) => {
              return data.users.some((metadataUser) => {
                return user.id === (metadataUser as any).id;
              });
            });
          }),
        );
      }),
    );
  }

  onConfirm() {
    if (!this.selectedProject) {
      return;
    }
    this.modalRef.close(this.selectedProject);
  }
}
